import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=4752b2e2&flex=true&"
import script from "./CampaignView.vue?vue&type=script&lang=js&"
export * from "./CampaignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCard,VCardText,VCol,VContainer,VDivider,VForm,VLabel,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/sam-backend/sam-backend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4752b2e2')) {
      api.createRecord('4752b2e2', component.options)
    } else {
      api.reload('4752b2e2', component.options)
    }
    module.hot.accept("./CampaignView.vue?vue&type=template&id=4752b2e2&flex=true&", function () {
      api.rerender('4752b2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CampaignView.vue"
export default component.exports